import { render, staticRenderFns } from "./mock-wine-release-landing.vue?vue&type=template&id=efd0961a&scoped=true&"
import script from "./mock-wine-release-landing.vue?vue&type=script&lang=js&"
export * from "./mock-wine-release-landing.vue?vue&type=script&lang=js&"
import style0 from "./mock-wine-release-landing.vue?vue&type=style&index=0&id=efd0961a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd0961a",
  null
  
)

export default component.exports